const ecosystemAboutPegasus = {
  title: 'PEGASUS ARMS ECOSYSTEM',
  timeLine: [
    {
      title: 'RESEARCH AND DEVELOPMENT',
      description:
        'A team of engineers and experts continuously improves existing solutions and creates new generations of drones.',
    },
    {
      title: 'IN-HOUSE PRODUCTION',
      description:
        'Serial assembly based on cutting-edge military technologies and innovations.',
    },
    {
      title: 'UAV/UAS OPERATOR TRAINING',
      description:
        'A full training course from scratch or retraining for experienced UAV/UAS specialists operating Pegasus Arms 25.',
    },
    {
      title: 'COMBAT PROVEN',
      description:
        'Pegasus Arms 25 is a strike drone that is constantly operating on the frontlines and has got the real combat experience.',
    },
  ],
}

export default ecosystemAboutPegasus
